import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { UdafBrandEditor, UdafImageSearch } from '@acclaim/udaf-kit';

import { useBrandSelectionStyles } from '../styles';

const BrandDecorator = ({
  selectedImage,
  handleBrandImageSelection,
  handleNextStep,
  sketchRef,
}) => {
  const classes = useBrandSelectionStyles();

  const handleSelectedImage = (image) => {
    handleBrandImageSelection(image);
  };

  return (
    <div className={classes.searchContainer}>
      <UdafBrandEditor
        hasUpload
        hasText
        sketchRef={sketchRef}
        imageUrl={selectedImage?.imageUrl}
        onNext={handleNextStep}
      />
      <br />
      <UdafImageSearch onSelect={handleSelectedImage} />
      <br />
      <Typography className={classes.lettersInstructions} >
        Type in at least one character, for example: <strong>#A, -2B, +-, =$, /,</strong> ☺, ♧, ♬<br />
        You can search for letters (ABC), numeric digits (123) or a few other characters in an image:
      </Typography>
      <ul className={classes.lettersInstructions}>
        <li>"<strong>$</strong>" to find a dollar sign</li>
        <li>"<strong>_</strong>" to find a bar</li>
        <li>"<strong>/</strong>" to find a slash</li>
        <li>"<strong>O</strong>" (letter oh) to find a circle, zero or letter O</li>
        <li>"<strong>(</strong>" to find a quarter circle</li>
        <li>"<strong>+</strong>" to find a cross</li>
      </ul>
    </div>
  );
};

BrandDecorator.propTypes = {
  sketchRef: PropTypes.object,
  selectedImage: PropTypes.object,
  handleBrandImageSelection: PropTypes.func.isRequired,
  handleNextStep: PropTypes.func.isRequired,
};

export default BrandDecorator;
